export const categories = [
  {
    slug: "wanghong-tafang",
    name: "网红塌房",
    description: "直击各路网红人设崩塌现场",
    tagline: "每一次塌房都是一场好戏",
    items: [
      {
        id: 101,
        title: "千万粉博主李某人设崩塌全记录",
        tag: "HOT",
        description: "私下辱骂粉丝录音曝光，品牌代言一夜全撤，合作方纷纷解约",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20photography%20of%20collapsing%20social%20media%20icons%2C%20shattered%20glass%20effect%2C%20red%20and%20black%20cinematic%20lighting%2C%20moody%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography&width=800&height=500&seq=cat-tafang-01&orientation=landscape",
        featured: true,
        date: "2026-07-06",
        articleId: "article-001",
      },
      {
        id: 102,
        title: "美妆博主整容前后惊天对比",
        tag: "NEW",
        description: "素人时期照片流出，粉丝：这谁？",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20cosmetic%20photography%2C%20beauty%20products%20on%20black%20surface%2C%20broken%20mirror%2C%20dramatic%20red%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-tafang-02&orientation=landscape",
        featured: false,
        date: "2026-07-05",
        articleId: "article-001",
      },
      {
        id: 103,
        title: "健身达人陈教练假补剂案最新进展",
        tag: "HOT",
        description: "法院已立案，涉案金额超三百万",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20fitness%20photography%2C%20supplements%20bottles%20on%20black%20floor%2C%20legal%20documents%20nearby%2C%20dramatic%20crimson%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-tafang-03&orientation=landscape",
        featured: false,
        date: "2026-07-05",
        articleId: "article-005",
      },
      {
        id: 104,
        title: "某知名大V学历造假事件持续发酵",
        tag: "NEW",
        description: "多所高校发声明澄清，当事人仍未回应",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20photography%20of%20fake%20certificates%2C%20university%20documents%2C%20dramatic%20red%20and%20black%20lighting%2C%20editorial%20style%2C%20moody%20noir%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-tafang-04&orientation=landscape",
        featured: false,
        date: "2026-07-04",
        articleId: "article-006",
      },
    ],
  },
  {
    slug: "heiliao-baoliao",
    name: "黑料爆料",
    description: "一手黑料，独家爆料，深度挖掘",
    tagline: "揭开光鲜背后的真相",
    items: [
      {
        id: 201,
        title: "某顶流带货主播虚假宣传内幕",
        tag: "HOT",
        description: "质检报告造假全流程曝光，涉及多个品牌",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20product%20photography%2C%20fake%20documents%20on%20black%20desk%2C%20dramatic%20red%20and%20black%20lighting%2C%20editorial%20style%2C%20moody%20noir%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=800&height=500&seq=cat-heiliao-01&orientation=landscape",
        featured: true,
        date: "2026-07-06",
        articleId: "article-002",
      },
      {
        id: 202,
        title: "电竞圈假赛风波：内部聊天记录完整版",
        tag: "NEW",
        description: "多名选手牵涉其中，圈内震动",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20esports%20scene%2C%20gaming%20gear%20on%20black%20desk%2C%20chat%20logs%20on%20screen%2C%20dramatic%20crimson%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-heiliao-02&orientation=landscape",
        featured: false,
        date: "2026-07-05",
        articleId: "article-004",
      },
      {
        id: 203,
        title: "情侣博主剧本炒作事件全揭秘",
        tag: "HOT",
        description: "前团队员工独家爆料幕后操作流程",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20film%20set%20photography%2C%20script%20papers%20and%20clapperboard%2C%20dramatic%20red%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-heiliao-03&orientation=landscape",
        featured: false,
        date: "2026-07-04",
        articleId: "article-003",
      },
    ],
  },
  {
    slug: "chigua-video",
    name: "吃瓜视频",
    description: "热门吃瓜视频合集，现场画面直击",
    tagline: "眼见为实，瓜要自己看",
    items: [
      {
        id: 301,
        title: "【视频】网红直播翻车现场实拍",
        tag: "HOT",
        description: "现场观众拍摄的独家画面，场面一度失控",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20live%20streaming%20setup%2C%20ring%20light%20with%20red%20glow%2C%20smartphone%20on%20tripod%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20moody%20noir%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=800&height=500&seq=cat-video-01&orientation=landscape",
        featured: true,
        date: "2026-07-06",
        articleId: "article-001",
      },
      {
        id: 302,
        title: "【视频】某明星街头争吵完整录像",
        tag: "NEW",
        description: "路人拍摄的十分钟完整视频曝光",
        imageUrl: "https://readdy.ai/api/search-image?query=Dark%20street%20photography%2C%20night%20scene%20with%20red%20neon%20lights%2C%20dramatic%20atmosphere%2C%20editorial%20style%2C%20moody%20cinematic%20lighting%2C%20dark%20background%2C%20professional%20photography&width=600&height=450&seq=cat-video-02&orientation=landscape",
        featured: false,
        date: "2026-07-05",
        articleId: "article-001",
      },
    ],
  },
];

export const reviews = [
  {
    id: 1,
    name: "微博吃瓜bot",
    username: "@weibo_chiguabot",
    avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%20photography%2C%20silhouette%20with%20phone%2C%20dramatic%20red%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=rev-avatar-01&orientation=squarish",
    quote: "连续追了三天这个塌房事件，你们的信息整理得比我们bot还全，respect！",
  },
  {
    id: 2,
    name: "路人甲233",
    username: "@passerby_233",
    avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%2C%20human%20silhouette%2C%20dramatic%20crimson%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=rev-avatar-02&orientation=squarish",
    quote: "这个网站简直是吃瓜神器，每天上班摸鱼必备！老板应该感谢你们让我工作效率提升了。",
  },
  {
    id: 3,
    name: "影视圈观察员",
    username: "@film_observer",
    avatarUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20portrait%20photography%2C%20silhouette%20with%20camera%2C%20dramatic%20red%20and%20black%20lighting%2C%20editorial%20style%2C%20moody%20atmosphere%2C%20dark%20background%2C%20professional%20photography&width=80&height=80&seq=rev-avatar-03&orientation=squarish",
    quote: "很多明星的瓜都是你们先扒出来的，我是你们忠实读者，每篇都看。",
  },
];